import type { ResourceTypeHandle } from '@toolproof-core/genesis/_contract/_index';
import type { SpaceAdapter } from '@toolproof-core/visualization/adapter/_contract/adapter';

import portalSnapshots from '@/adapters/episode/_data/portalSnapshots.json' with { type: 'json' };

import { runtimeController } from '@/adapters/episode/_pure/runtimeController';
import { createSpaceDeriver } from '@/adapters/episode/framePipeline';
import { SPACE_KEY } from '@/adapters/episode/spaceIdentity';
import type { SpaceAdapterDescriptor } from '@/_contract/types';
import type { CosmosDataModel, Config, EpisodeRing, RuntimeState } from '@/adapters/episode/_contract/config';

const CONFIG: Config = {};

const spaceAdapter: SpaceAdapter<ResourceTypeHandle, CosmosDataModel, Config, RuntimeState> = {
    createSpaceDeriver,
};

/** The registry supplies the rings, so this adapter never imports the spaces it presents. */
export function createDescriptor(rings: readonly EpisodeRing[]) {
    return {
        baseDescriptor: {
            spaceKey: SPACE_KEY,
            adapter: spaceAdapter,
            getResourceTypeInputSpec: () => ({ requiredResourceTypes: [] }),
            buildCosmosData: (resourcesByType) => ({ resourcesByType, rings, snapshotUrlByHandle: portalSnapshots }),
            defaultConfig: CONFIG,
        },
        runtime: {
            kind: 'single',
            controller: runtimeController,
        },
    } as const satisfies SpaceAdapterDescriptor<ResourceTypeHandle, CosmosDataModel, Config, RuntimeState>;
}

export type AdapterDescriptor = ReturnType<typeof createDescriptor>;
